export const FileFilterOptions = [
  { value: "all", label: "All Files" },
  { value: "images", label: "Images" },
];
